export enum BidPriceType {
  /**
   * 单价
   */
  UNIT_PRICE = 0,
  /**
   * 总价
   */
  TOTAL_PRICE = 1
}

export const BidPriceTypeTextMap: Record<BidPriceType, string> = {
  [BidPriceType.UNIT_PRICE]: '单价',
  [BidPriceType.TOTAL_PRICE]: '总价'
}
